export interface EcommerceError {
  requestedUrl: string | null;
  message: string;
  key: string;
  httpStatus: number;
  originalError: unknown;
}

export function isEcommerceError(error: unknown): error is EcommerceError {
  return (isDefined(error)
    && isDefined((error as EcommerceError).message)
    && isDefined((error as EcommerceError).key)
    && isDefined((error as EcommerceError).httpStatus));
}
